import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Modal } from 'antd';
import { Grid, Card } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import MainContainer from '../../../components/MainContainer';
import SidebarList from './SidebarList';
import SidebarUpdate from './SidebarUpdate';

@inject(
    'loginStore',
    'CmsLanguageStore',
    'CmsSidebarStore'
)
@observer
class SidebarPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
        
        this.props.CmsSidebarStore.getAll();
        this.props.CmsLanguageStore.getActives();
    }

    componentWillUnmount() {
        this.props.CmsSidebarStore.setshowModal(false);
    }

    cancelModal = () => {
        this.props.CmsSidebarStore.setshowModal(false);
    }

    render() {
        const { t } = this.props;
        const {
            showModal,
            modalTitle
        } = this.props.CmsSidebarStore;

        return (
            <MainContainer title={t('Compendium Management')} menukey='sidebars'>
                <Modal
                    title={t(modalTitle)}
                    visible={showModal}
                    width={800}
                    footer={null}
                    onCancel={this.cancelModal}
                    zIndex={1000}
                >
                    <SidebarUpdate />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <SidebarList />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(SidebarPage);